import React from "react";
import OrderHistory from "../components/order/OrderHistory";

function OrderHistoryPage(props) {
  return <OrderHistory props={props} />;
}

export default OrderHistoryPage;
